/**
 * Bild-Knoten für den HTML-Editor.
 *
 * Bewusst **ohne** `@tiptap/extension-image`: das Paket zieht eine neuere
 * `@tiptap/core`-Version nach, wodurch npm 120 Cypress-Abhängigkeiten aus der
 * Sperrdatei entfernt und der Editor auf einen anderen Kern gehoben würde. Der
 * Knoten hier ist wenige Zeilen groß und nutzt nur den vorhandenen Kern.
 *
 * `data:`-Quellen sind ausdrücklich erlaubt — genau das brauchen Signaturen,
 * weil ein Logo in der E-Mail mitreisen muss und nicht von einem Server
 * nachgeladen werden darf.
 */

import { Node, mergeAttributes } from '@tiptap/core';

export const EditorImage = Node.create({
  name: 'image',
  group: 'block',
  inline: false,
  draggable: true,
  atom: true,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      title: { default: null },
      width: { default: null },
      height: { default: null },
      style: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'img[src]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['img', mergeAttributes(HTMLAttributes)];
  },
});
